import Header from "./Header";

const Layout = ({ children, activePage, menuActive ,setMenuActive, showHeader = true }) => {
  return (
        <>
            <div className='main-wrapper'>
                {showHeader && <Header activePage={activePage} menuActive={menuActive} setMenuActive={setMenuActive}/>}
                <div className={`${showHeader ? 'main-content': 'main-content-login'}`}>
                    {children}
                </div>
            </div>
        </>
    );
}

export default Layout
